import { useState } from 'react';
import i18n from 'i18';
import { Box, Button, MenuItem, Typography } from '@mui/material';
import { ReactComponent as UploadIcon } from './UploadIcon.svg';
import Select from '@mui/material/Select';
import { styled } from '@mui/system';

const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiSelect-select': {
        "padding": '5px 15px',
        "border": `1px solid ${theme.palette.secondary.light}`,
        "color": theme.palette.secondary.main,
        "background": theme.palette.background.default,
        '&:hover': {
            backgroundColor: theme.palette.secondary.lighter,
            border: `1px solid ${theme.palette.secondary.light}`
        }
    }
}));

export default function AppReport({ title, subtitle, handleExport }) {
    const currentMonth = new Date().getMonth();
    const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];
    const [month, setMonth] = useState(months[currentMonth]);
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}
        >
            <Box
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
                gap={2}
            >
                <UploadIcon />
                <Box>
                    <Typography
                        variant="subtitle1"
                        sx={{ color: 'text.default' }}
                    >
                        {title}
                    </Typography>
                    <Typography
                        variant="caption"
                        sx={{ color: 'text.disabled' }}
                    >
                        {subtitle}
                    </Typography>
                </Box>
            </Box>

            <Box display="flex" gap={1}>
                <StyledSelect
                    value={month}
                    onChange={(e) => setMonth(e.target.value)}
                >
                    {months.map((m) => (
                        <MenuItem key={m} value={m}>
                            <Typography variant="subtitle2">{m}</Typography>
                        </MenuItem>
                    ))}
                </StyledSelect>
                <Button
                    variant={'outlined'}
                    color={'secondary'}
                    onClick={handleExport}
                >
                    {i18n.t('buttons.exportAsCsv')}
                </Button>
            </Box>
        </Box>
    );
}
